import React from "react";

import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "../materialDashboard/components/MDBox";


export const useSidePanel = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    const close = () => {
        setIsOpen(false);
    }

    const open = () => {
        setIsOpen(true);
    }

    const toggle = () => {
        setIsOpen(prev => !prev);
    }

    return {isOpen, open, close, toggle};
}


const SidePanel = ({open, onClose, title, children, width="50vw", sx={}}) => {

    return <Collapse orientation="horizontal"
                     in={open}
                     sx={{height: "100%", maxHeight: "100%", flexShrink: 0, zIndex: 200, ml: 0}}>
        <MDBox borderRadius="xl"
               bgColor="white"
               sx={{width: {xs: "calc(100vw - 8px)", lg: width}, height: "100%", overflow: "auto", maxWidth: "100%", background: "white", ...sx}}>
            <MDBox p={2} sx={{position: "sticky", top: 0, background: "white", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                { title }
                <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    aria-controls="notification-menu"
                    variant="contained"
                    onClick={onClose}
                >
                    <Icon>close</Icon>
                </IconButton>
            </MDBox>
            <MDBox sx={{maxWidth: "100%", overflowX: "hidden", px: 2}}>
                { children }
            </MDBox>
        </MDBox>
    </Collapse>
}

export default SidePanel;